module.exports = __webpack_public_path__ + "static/media/duplicate_entries.57a64460.png";